/* Page C: Gym Launch. Break-even calculator (first screen), member floor plan, sign-up payload, proof rail.
   Vanilla JS, no dependencies. Loads after ../shared/verve.js. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var track = function (n, d) { if (window.verveTrack) window.verveTrack(n, d); };
  var NF = new Intl.NumberFormat('en-AU', { maximumFractionDigits: 0 });
  function money(v) { return (v < 0 ? '-$' : '$') + NF.format(Math.abs(Math.round(v))); }
  var NF1 = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  var NF2 = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function one(v) { return NF1.format(Math.round(v * 10) / 10); }
  // the working shows cents where they matter, so anyone can check the sum on a calculator
  function cents(v) { return Math.abs(v - Math.round(v)) < 0.005 ? money(v) : '$' + NF2.format(v); }

  /* ================= break-even calculator ================= */
  var calc = document.querySelector('[data-calc]');
  var EXAMPLE = { rent: 1500, fitout: 85000, cash: 25000, years: 5, rate: 10, other: 6000, price: 55 };
  var state = {};
  var edited = false;
  var fields = {};

  var FMT = {
    money: function (v) { return money(v); },
    years: function (v) { return v + (v === 1 ? ' yr' : ' yrs'); },
    pct: function (v) { return (Math.round(v * 100) / 100) + '%'; }
  };

  function compute(s) {
    var rentMonthly = s.rent * 52 / 12;
    var principal = Math.max(0, s.fitout - s.cash);
    var r = s.rate / 100 / 12;
    var n = s.years * 12;
    var repay = principal === 0 ? 0 : (r > 0 ? principal * r / (1 - Math.pow(1 + r, -n)) : principal / n);
    var costs = rentMonthly + repay + s.other;
    var perMember = s.price * 52 / 12;
    var exact = costs / perMember;
    return { rentMonthly: rentMonthly, principal: principal, n: n, repay: repay, costs: costs, perMember: perMember, exact: exact, members: Math.ceil(exact - 1e-9) };
  }

  /* ----- the floor plan: ~400 member positions, filled outward from the door ----- */
  var CAP = 400;
  var plan = calc && calc.querySelector('.plan');
  var dotsG = calc && calc.querySelector('[data-dots]');
  var moreEl = calc && calc.querySelector('[data-more]');
  var dots = [];
  var shown = 0;
  var dotsReady = false;
  function hash(i) { var x = Math.sin(i * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  function positions() {
    var P = [], dx = 15, dy = 12.2, j = 0;
    for (var y = 56; y <= 246; y += dy, j++) {
      for (var x = 19 + (j % 2) * dx / 2; x <= 423; x += dx) {
        if (Math.hypot(x - 36, y - 256) < 58) continue;            // door swing
        if (x > 404 && y < 138) continue;                           // dumbbell rack
        if (Math.abs(x - 153) < 15 && Math.abs(y - 131) < 15) continue; // columns
        if (Math.abs(x - 295) < 15 && Math.abs(y - 131) < 15) continue;
        var k = P.length;
        P.push({ x: x + (hash(k) - .5) * 2.4, y: y + (hash(k + 99) - .5) * 2.4 });
      }
    }
    // order by farthest-point sampling, starting by the door: every count reads as an evenly used floor
    var out = [], best = [], used = [], pick = 0, q;
    for (q = 0; q < P.length; q++) {
      best[q] = Infinity;
      if (Math.hypot(P[q].x - 70, P[q].y - 236) < Math.hypot(P[pick].x - 70, P[pick].y - 236)) pick = q;
    }
    while (pick > -1 && out.length < Math.min(CAP, P.length)) {
      used[pick] = true; out.push(P[pick]);
      var far = -1, fd = -1;
      for (q = 0; q < P.length; q++) {
        if (used[q]) continue;
        best[q] = Math.min(best[q], Math.hypot(P[q].x - P[pick].x, P[q].y - P[pick].y));
        var score = best[q] + hash(q + 3) * 1.5;
        if (score > fd) { fd = score; far = q; }
      }
      pick = far;
    }
    return out;
  }
  function buildDots() {
    if (!dotsG) return;
    var P = positions();
    CAP = P.length;
    var NS = 'http://www.w3.org/2000/svg';
    dotsG.textContent = '';
    P.forEach(function (p) {
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', p.x.toFixed(1)); c.setAttribute('cy', p.y.toFixed(1)); c.setAttribute('r', '3.6');
      c.style.display = 'none';
      dotsG.appendChild(c); dots.push(c);
    });
  }
  function drawDots(n) {
    if (!dots.length) return;
    var target = Math.min(n, CAP);
    for (var i = 0; i < CAP; i++) {
      var on = i < target;
      var c = dots[i];
      // new dots pop in only after the visitor moves something (never on load)
      if (on && c.style.display === 'none') { c.style.display = ''; if (dotsReady) c.classList.add('in'); }
      else if (!on && c.style.display !== 'none') { c.style.display = 'none'; c.classList.remove('in'); }
    }
    shown = target;
    if (moreEl) {
      var extra = n - CAP;
      moreEl.hidden = extra <= 0;
      if (extra > 0) moreEl.textContent = '+' + NF.format(extra) + ' MORE';
    }
  }

  /* ----- render ----- */
  var outs = function (k) { return document.querySelectorAll('[data-out="' + k + '"]'); };
  var setOut = function (k, v) { outs(k).forEach(function (el) { el.textContent = v; }); };
  var workBody = calc && calc.querySelector('[data-work-body] .work__rows');
  var live = calc && calc.querySelector('[data-calc-live]');
  var note = calc && calc.querySelector('[data-calc-note]');
  var resetBtn = calc && calc.querySelector('[data-calc-reset]');
  var mineLabel = document.querySelector('[data-mine-label]');

  function render() {
    var s = state, o = compute(s);
    var membersTxt = NF.format(o.members);
    setOut('members', membersTxt);
    var big = calc.querySelector('.calc__n');
    if (big) big.setAttribute('data-len', membersTxt.length <= 2 ? '2' : membersTxt.length === 3 ? '3' : '5');
    var rentR = Math.round(o.rentMonthly), repR = Math.round(o.repay), othR = Math.round(s.other);
    var costsShown = rentR + repR + othR; // the parts on screen always add up
    setOut('costs', money(costsShown));
    setOut('repay', money(o.repay));
    setOut('per', money(o.perMember));
    var ms = calc.querySelector('[data-more-sum]');
    if (ms) ms.textContent = money(s.cash) + ' cash, ' + FMT.years(s.years) + ' at ' + FMT.pct(s.rate) + ', ' + money(s.other) + ' a month other costs';
    drawDots(o.members);

    if (workBody) {
      var loanLine = o.principal === 0
        ? 'No loan: your cash covers the fit-out'
        : money(s.fitout) + ' fit-out − ' + money(s.cash) + ' cash = ' + money(o.principal) + ' borrowed, over ' + o.n + ' months at ' + FMT.pct(s.rate) + ' a year';
      workBody.innerHTML =
        row('Rent', money(s.rent) + ' a week × 52 weeks ÷ 12 months', money(rentR)) +
        row('Loan', loanLine, money(repR)) +
        row('Other costs', 'Staff, power, software, insurance', money(othR)) +
        row('Costs a month', 'Rent + loan + other costs', money(costsShown), true) +
        row('Each member', money(s.price) + ' a week × 52 weeks ÷ 12 months', cents(o.perMember)) +
        row('Break-even', money(costsShown) + ' ÷ ' + cents(o.perMember) + ' = ' + one(o.exact) + ', rounded up to a whole member', membersTxt + (o.members === 1 ? ' member' : ' members'), true);
    }

    // hidden fields on the sign-up form
    var vals = { rent: s.rent, fitout: s.fitout, cash: s.cash, years: s.years, rate: s.rate, other: s.other, price: s.price, costs: costsShown, repay: repR, members: o.members, edited: edited ? 'yes' : 'no' };
    document.querySelectorAll('[data-calc-field]').forEach(function (f) { var k = f.getAttribute('data-calc-field'); if (k in vals) f.value = vals[k]; });

    if (note) note.textContent = edited ? 'Your figures.' : 'Example figures. Change them to yours.';
    if (resetBtn) resetBtn.hidden = !edited;
    if (mineLabel) mineLabel.textContent = edited ? 'YOUR NUMBERS' : 'YOUR NUMBERS, EXAMPLE FIGURES';
    return o;
  }
  function row(t, how, eq, tot) {
    return '<div' + (tot ? ' class="work__tot"' : '') + '><dt>' + t + '</dt><dd>' + how + '</dd><dd class="work__eq">' + eq + '</dd></div>';
  }
  function announce() {
    if (!live) return;
    var o = compute(state);
    live.textContent = 'You need ' + NF.format(o.members) + ' members to break even. Monthly costs ' + money(o.costs) + '.';
  }

  function setPct(f) {
    var r = f.range, v = +r.value;
    var p = (v - +r.min) / ((+r.max - +r.min) || 1) * 100;
    r.style.setProperty('--p', Math.max(0, Math.min(100, p)).toFixed(2) + '%');
  }
  // the typed-figure box hugs its value, so labels keep their room on narrow columns
  function fitNum(f, len) { f.num.style.width = 'calc(' + (len + 0.45) + 'ch + ' + (len * 0.05).toFixed(2) + 'em + 18px)'; }
  function showVal(f) { if (document.activeElement !== f.num) { f.num.value = FMT[f.fmt](state[f.key]); fitNum(f, f.num.value.length); } }

  function setVal(key, v, from) {
    var f = fields[key];
    var min = +f.range.min, max = +f.range.max;
    v = Math.max(min, Math.min(max, v));
    state[key] = v;
    if (from !== 'range') f.range.value = v;
    setPct(f); showVal(f);
    if (key === 'fitout') {
      // cash can't be more than the fit-out
      var c = fields.cash;
      c.range.max = v;
      if (state.cash > v) { state.cash = v; c.range.value = v; showVal(c); }
      setPct(c);
    }
  }
  function markEdited() {
    if (edited) return;
    edited = true;
    track('calc_first_edit');
  }

  var changeTimer;
  function onChanged() {
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      announce();
      var o = compute(state);
      track('calc_change', { members: o.members, rent: state.rent, fitout: state.fitout, price: state.price });
    }, 500);
  }

  function parseNum(str) {
    var m = String(str).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  if (calc) {
    calc.querySelectorAll('.sl').forEach(function (el) {
      var key = el.getAttribute('data-key');
      var f = { key: key, el: el, fmt: el.getAttribute('data-fmt'), range: el.querySelector('.sl__range'), num: el.querySelector('.sl__num') };
      fields[key] = f;
      state[key] = EXAMPLE[key];
      f.range.addEventListener('input', function () {
        markEdited();
        setVal(key, +f.range.value, 'range');
        render();
      });
      f.range.addEventListener('change', onChanged);
      f.num.addEventListener('focus', function () {
        f.num.value = String(state[key]);
        fitNum(f, Math.max(4, String(f.range.max).length + 1));
        setTimeout(function () { try { f.num.select(); } catch (e) {} }, 0);
      });
      function commit() {
        var v = parseNum(f.num.value);
        if (!isNaN(v) && v !== state[key]) {
          if (key === 'years') v = Math.round(v);
          markEdited();
          setVal(key, v, 'num');
          render(); onChanged();
        }
        f.num.value = FMT[f.fmt](state[key]);
        fitNum(f, f.num.value.length);
      }
      f.num.addEventListener('blur', commit);
      f.num.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); commit(); f.num.blur(); }
        else if (e.key === 'Escape') { f.num.value = String(state[key]); f.num.blur(); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault();
          var step = +f.range.step || 1;
          markEdited();
          setVal(key, (parseNum(f.num.value) || state[key]) + (e.key === 'ArrowUp' ? step : -step), 'num');
          f.num.value = String(state[key]);
          render(); onChanged();
        }
      });
    });

    if (resetBtn) resetBtn.addEventListener('click', function () {
      edited = false;
      setVal('fitout', EXAMPLE.fitout);
      Object.keys(EXAMPLE).forEach(function (k) { setVal(k, EXAMPLE[k]); });
      render(); announce();
      track('calc_reset');
    });

    Object.keys(fields).forEach(function (k) { showVal(fields[k]); });
    var more = calc.querySelector('[data-calc-more]');
    if (more && matchMedia('(min-width:721px)').matches) more.open = true; // phones start with the three key sliders
    buildDots();
    render();
    dotsReady = true;
    if (plan) plan.classList.add('is-live');

    // "Save these numbers" and the sign-up summary
    var save = calc.querySelector('[data-calc-save]');
    if (save) save.addEventListener('click', function () { track('calc_save_click', { members: compute(state).members }); });
    var work = calc.querySelector('[data-work]');
    if (work) work.addEventListener('toggle', function () { if (work.open) track('calc_show_working'); });

    // sticky mini readout: shown once the sliders scroll under the header and the big number is gone
    var ins = calc.querySelector('.calc__in');
    var peekBar = calc.querySelector('.calc__peekbar');
    if (ins && peekBar) {
      var ticking = false;
      var peek = function () {
        ticking = false;
        if (!peekBar.offsetParent) return; // hidden on two-column layouts
        var hdr = document.querySelector('.lhdr');
        var top = (hdr ? hdr.offsetHeight : 60) + 10;
        var r = ins.getBoundingClientRect();
        calc.classList.toggle('is-peek', r.top < top - 4 && r.bottom > top + 140);
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(peek); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      peek();
    }
  }

  /* ================= sign-up: build the portal payload ================= */
  // round 14: two copies of the direct form (under the calculator, and in the sheet), both build the payload
  var forms = document.querySelectorAll('[data-tools-form]');
  var GYM_TYPE = {
    'Strength and conditioning': 'commercial',
    'Boutique or studio': 'boutique',
    'Functional or CrossFit-style': 'crossfit',
    '24/7 or franchise': 'franchise',
    'PT studio': 'pt_studio',
    'Allied health or rehab': 'other',
    'Something else': 'other'
  };
  function cookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function uuid() {
    try { if (crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'gl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  Array.prototype.forEach.call(forms, function (form) {
    form.addEventListener('submit', function () {
      var fd = new FormData(form);
      var get = function (k) { return (fd.get(k) || '').toString().trim(); };
      var name = get('fullname').split(/\s+/);
      var first = get('firstname') || name.shift() || '', last = get('lastname') || name.join(' ');
      if (!first || !get('email') || !get('phone') || !get('opening') || !get('gym_type')) return;
      var fbclid = new URLSearchParams(location.search).get('fbclid');
      var payload = {
        firstName: first,
        lastName: last,
        email: get('email'),
        phone: get('phone'),
        gymType: GYM_TYPE[get('gym_type')] || 'other',
        timeline: get('opening'),
        suburb: get('suburb'),
        company: '',
        event_id: uuid(),
        fbp: cookie('_fbp'),
        fbc: cookie('_fbc') || (fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : ''),
        event_source_url: location.href,
        // extra context for the portal / HubSpot (needs a field on the portal side)
        gymTypeDetail: get('gym_type'),
        source: get('source'),
        calculator: {
          rentPerWeek: +get('calc_rent_per_week'), fitoutTotal: +get('calc_fitout_total'), cashIn: +get('calc_cash_in'),
          loanYears: +get('calc_loan_years'), interestRate: +get('calc_interest_rate'), otherMonthly: +get('calc_other_monthly'),
          membershipPerWeek: +get('calc_membership_per_week'), monthlyCosts: +get('calc_monthly_costs'),
          loanRepaymentMonthly: +get('calc_loan_repayment_monthly'), breakEvenMembers: +get('calc_break_even_members'),
          edited: get('calc_edited') === 'yes'
        }
      };
      // CONCEPT ONLY: nothing is sent. Live version: fetch('https://gymlaunch.vervefitness.com/api/access-request',
      //   { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }) once CORS allows the store origin.
      window.verveGymLaunchPayload = payload;
      track('gym_launch_signup', { gymType: payload.gymType, timeline: payload.timeline, members: payload.calculator.breakEvenMembers, form: form.id });
    });
  });

  /* ================= proof rail arrows ================= */
  var rail = document.querySelector('[data-rail]');
  if (rail) {
    var prev = document.querySelector('[data-rail-prev]');
    var next = document.querySelector('[data-rail-next]');
    var stepW = function () { var c = rail.querySelector('.case'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 22) : 300; };
    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    };
    var go = function (dir) { rail.scrollBy({ left: dir * stepW(), behavior: reduce ? 'auto' : 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
})();

/* tools journey: one stage at a time (round 2) */
(function () {
  var tj = document.querySelector('[data-tj]'); if (!tj) return;
  var tabs = [].slice.call(tj.querySelectorAll('.tj__tab'));
  var panels = [].slice.call(tj.querySelectorAll('.tj__panel'));
  var fill = tj.querySelector('[data-tj-fill]');
  var cur = 0;
  function show(n, focus) {
    cur = Math.max(0, Math.min(tabs.length - 1, n));
    tabs.forEach(function (t, k) { var on = k === cur; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
    panels.forEach(function (p, k) { p.hidden = k !== cur; });
    var cards = panels[cur].querySelector('.tj__cards'); if (cards) cards.scrollLeft = 0;
    if (fill) fill.style.width = ((cur + 1) / tabs.length * 100) + '%';
    if (focus) tabs[cur].focus();
    if (window.verveTrack) window.verveTrack('tools_stage', { stage: tabs[cur].querySelector('.tj__tname').textContent });
  }
  tabs.forEach(function (t, k) {
    t.addEventListener('click', function () { show(k); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1, true); }
    });
  });
  tj.addEventListener('click', function (e) {
    if (!e.target.closest('[data-tj-next]')) return;
    show(cur + 1);
    var top = tj.querySelector('.tj__bar').getBoundingClientRect().top;
    var hdr = (document.querySelector('.lhdr') || {}).offsetHeight || 60;
    if (top < hdr || top > innerHeight * 0.4) scrollTo({ top: scrollY + tj.getBoundingClientRect().top - hdr - 16, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  show(0);
})();
